"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addYouTubeApiToPage = void 0;
const qsOrThrowFit_1 = require("./qsOrThrowFit");
const addYouTubeApiToPage = () => new Promise((res) => {
    var _a;
    if (window.onYouTubeIframeAPIReady)
        res();
    const script = document.createElement("script");
    script.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = (0, qsOrThrowFit_1.qsOrThrowFit)("script");
    (_a = firstScriptTag.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(script, firstScriptTag);
    if (!script.parentNode)
        throw new Error("Could not attach YouTube script to document");
    window.onYouTubeIframeAPIReady = res;
});
exports.addYouTubeApiToPage = addYouTubeApiToPage;
